export const FORMS_CONSTANTS = {
  TITLE: "Formularios",
  FORM_TEXT: "Formulario",
  STATE: {
    COMPLETE: "Completo",
    INCOMPLETE: "Incompleto",
    DELETED: "Eliminado"
  },
  FIELD_TYPE: {
    LIST: "lista",
    BASIC: "basico"
  },
  FIELD: {
    CHECKBOX: "checkbox",
    RADIO: "radio",
    SELECT: "select"
  },
  BUTTON: {
    SEND_FORM: "Enviar formulario",
    UPDATE_FORM: "Actualizar",
    SAVE_FORM: "Guardar Cambios",
    DELETE_TASK: "Eliminar tarea",
    RESPONSABLE_TASK: "Responsable",
    CANCEL_FORM: "Cancelar"
  },
  PENDING_TEXT: "Pendiente",
  SNACKBAR_MSG: {
    EMPTY_FIELDS: "Por favor llene todos los campos requeridos",
    ERROR_LOAD: "Ha ocurrido un error al intentar cargar",
    EMPTY_FIELDS_DRAFT: "Por favor ingrese algun dato para guardar el borrador"
  },
  TEXT: {
    CATEGORY: "Categoría:",
    TYPE: "Tipo:"
  },
  FORMS_NOT_FOUND: "No hay formularios para mostrar",
  EVENTS: {
    STATE_COMPLETE: "completeEvent"
  }
};

export const FORMS_ACCESS = {
  GET: "consultar formularios",
  POST: "crear formularios",
  PUT: "modificar formularios",
  DELETE: "eliminar formularios"
};

export const PROFILE_ROUTE = "/profile/";
